import { fieldTypes } from "../../../common/form/fieldTypes";
import { DynamicSpacer, DynamicDivider, DynamicBadge, DynamicHtml, DynamicIcon, DynamicTable } from "../Comps/DynamicContents";
import { DynamicCondition, DynamicBlock, DynamicGroupBlock, DynamicContaner, DynamicDetails, DynamicGrid, DynamicAccordion, DynamicCallout, DynamicList } from "../Comps/DynamicContainers";
import { DynamicCanadaAddress, 
  DynamicDateOfBirthInput, 
  DynamicPhoneMobile, 
  DynamicMapLocation, 
  DynamicMapViewer,  
  DynamicBankDetails,
  DynamicFirstNationStatusDetails, 
  DynamicFamilyMembers } from "../Comps/DynamicWidgets";
import { DynamicButton, DynamicIconButton, DynamicButtonGroup } from "../Comps/DynamicButtons";
import { DynamicFormValue,
          DynamicFormTextInput,
          DynamicFormNumberInput,
          DynamicFormTextAreaInput,
          DynamicFormDateInput,
          DynamicFormCheckInput,
          DynamicFormDropdownInput,
          DynamicFormRadioInput,
          DynamicFormFileInput,
          DynamicFormInput } from "../Comps/DynamicFormInputs";
import { evaluate } from "../../../utils/globalUtility";


const getFields = ({ field, form, getResourceValue, getRefData, clickHandlers, fieldKey, context, setShowStepActionButtons, setFormData, supportInfo = "" }) => {

  if (!!field.condition?.stepName && context.getStepData) {
    const stepData = context.getStepData(field.condition.stepName);
    context[field.condition.stepName]=stepData;
  }
  if (!!field.condition?.category) {
    context[field.condition?.category] = getRefData({category: field.condition?.category});
  }

  const expressionValue = evaluate(field.condition, context, form?.values || {});

  if (field.condition?.action) {
    if (expressionValue === true) {
      if (field.condition?.action === 'hidden') {
        return;
      }
      if (field.condition?.action === 'next') {
        if (!context.previousButtonClicked && !!clickHandlers['next']) {
          setTimeout(() => {
            clickHandlers['next'](field.condition.defaultStepData ? {...field.condition.defaultStepData, isInternal: true} : {});
          }, 0);
        }
        if (context.previousButtonClicked && !!clickHandlers['previous']) {
          setTimeout(() => {
            clickHandlers['previous']({});
          }, 0);
        }
      } 
    }
    field.properties = {...field.properties, [field.condition?.action]: expressionValue};
  }

  switch (field.type) {
    case fieldTypes.html:
      return (
          <DynamicHtml key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
      );
    case fieldTypes.block:
      return (
        <DynamicBlock key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
      );
    case fieldTypes.groupBlock:
      return (
        <DynamicGroupBlock key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
      );
    case fieldTypes.condition:
      return (
          <DynamicCondition key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
      );
    case fieldTypes.grid:
      return (
          <DynamicGrid key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
      );
    case fieldTypes.container:
      return (
          <DynamicContaner key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
      );
    case fieldTypes.details:
      return (
          <DynamicDetails key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
      );
    case fieldTypes.accordion:
      return (
          <DynamicAccordion key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
    );
    case fieldTypes.callout:
      return (
          <DynamicCallout key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData} />
    );
    case fieldTypes.spacer:
      return (
        <DynamicSpacer key={fieldKey} field={field} />
      );
    case fieldTypes.divider:
      return (
        <DynamicDivider key={fieldKey} field={field} />
      );
    case fieldTypes.badge:
      return (
        <DynamicBadge key={fieldKey} field={field} getResourceValue={getResourceValue} context={context} />
      );
    case fieldTypes.icon:
      return (
        <DynamicIcon key={fieldKey} field={field} />
      );
    case fieldTypes.table:
      return (
          <DynamicTable key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} />
      );
    case fieldTypes.list:
      return (
          <DynamicList key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} context={context} clickHandlers={clickHandlers} setFormData={setFormData} />
      );
    case fieldTypes.button:
      return (
          <DynamicButton key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} clickHandlers={clickHandlers} />
      );
    case fieldTypes.iconButton:
      return (
          <DynamicIconButton key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} clickHandlers={clickHandlers} />
      );
    case fieldTypes.buttonGroup:
      return (
        <DynamicButtonGroup key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} clickHandlers={clickHandlers} setFormData={setFormData} />
      );
    case fieldTypes.dateWidget:
      return (
        <DynamicDateOfBirthInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} context={context} setFormData={setFormData} />
      );
    case fieldTypes.phoneWidget:
      return (
        <DynamicPhoneMobile key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      );
    case fieldTypes.addressWidget:
      return (
        <DynamicCanadaAddress key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      );
    case fieldTypes.firstNationStatusWidget:
      return (
        <DynamicFirstNationStatusDetails key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} setFormData={setFormData} />
      );
    case fieldTypes.familyMembersWidget:
      return (
        <DynamicFamilyMembers key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} setShowStepActionButtons={setShowStepActionButtons} setFormData={setFormData} context={context} />
      );
    case fieldTypes.mapLocationWidget:
      return (
        <DynamicMapLocation key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} setFormData={setFormData} />
      );
    case fieldTypes.mapViewerWidget:
      return (
        <DynamicMapViewer key={fieldKey} field={field} form={form} context={context} />
      );
      case fieldTypes.bankDetailsWidget:
        return (
          <DynamicBankDetails key={fieldKey} field={field} form={form} context={context} getResourceValue={getResourceValue} setFormData={setFormData}/>
        );
    case fieldTypes.value:
      return (
        <DynamicFormValue key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} context={context} setFormData={setFormData} clickHandlers={clickHandlers} supportInfo={supportInfo} />
      )
    case fieldTypes.text:
      return (
        <DynamicFormTextInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      )
    case fieldTypes.number:
      return (
        <DynamicFormNumberInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      )
    case fieldTypes.textarea:
      return (
        <DynamicFormTextAreaInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      )
    case fieldTypes.date:
      return (
        <DynamicFormDateInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      )
    case fieldTypes.dropdown:
      return (
        <DynamicFormDropdownInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} context={context} setFormData={setFormData} />
      )
    case fieldTypes.radio:
      return (
        <DynamicFormRadioInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} getRefData={getRefData} context={context} setFormData={setFormData} />
      )
    case fieldTypes.check:
      return (        
        <DynamicFormCheckInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      );
    case fieldTypes.file:
      return (
        <DynamicFormFileInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} />
      );
    case fieldTypes.input:
    default:
      return (
        <DynamicFormInput key={fieldKey} field={field} form={form} getResourceValue={getResourceValue} context={context} setFormData={setFormData} />
      );
  }
};

export const DynamicFields = ({ children, form, getResourceValue, getRefData, clickHandlers, context, setShowStepActionButtons, setFormData, supportInfo = "" }) => {

  return (
    <>
        {(children ?? []).map((child, index) =>
            getFields({ field: child, form, getResourceValue, getRefData, clickHandlers, fieldKey: index, context, setShowStepActionButtons, setFormData, supportInfo })
        )}
    </>
  );
};